import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackAddPaymentInfoParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackAddPaymentInfo";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackAddPaymentInfo = (
    parameters: PartialSpecific<TrackAddPaymentInfoParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackAddPaymentInfoParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        promotions: ga.use.promotions(options),
        cart: ga.use.cart(options, true),
        ...options,
    };

    return (parameters: Partial<TrackAddPaymentInfoParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.addPaymentInfo({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackAddPaymentInfo;
